/**
 * Created by jxm on 16-6-6.
 * 存放全局变量
 */
module.exports = {
  curRoute: {
    path: '',
    pathName: '',
    params: {},
    backpath: ''
  },
  activationCode: '',
  signUserId: null,
  currentTab: 1,
  app: 0,
  isWKWebView: 0,
  enterId: null,
  language: '',

  interCode: [
    {
      short: 'CN',
      name: '中国',
      en: 'China',
      tel: '86',
      pinyin: 'zg',
    },
    {
      short: 'HK',
      name: '香港(中国)',
      en: 'Hongkong',
      tel: '852',
      pinyin: 'xgzg',
    },
    {
      short: 'MO',
      name: '澳门(中国)',
      en: 'Macao',
      tel: '853',
      pinyin: 'am zg',
    },
    {
      short: 'TW',
      name: '台湾(中国)',
      en: 'Taiwan',
      tel: '886',
      pinyin: 'twzg',
    },
  ],
  interCodeReg: {
    '1': /^[0-9]{10}$/,
    '86': /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
    '852': /^(5|6|8|9)\d{7}$/,
    '853': /^6\d{7}$/,
    '886': /^09\d{8}$/,
  },
};


//////////////////
// WEBPACK FOOTER
// ./src/constant.js
// module id = 300
// module chunks = 5